const choo = require('choo')
const playingView = require('./views/play.js')
const browserView = require('./views/scaffold-project-browser.js')
const store = require('./store.js')
const fullscreenPlayer = require('./views/fullscreen-player.js')

const app = choo({ hash: true })

app.use(store)

app.route('/v2/:project_id', fullscreenPlayer)

app.route('/play/:project_id', fullscreenPlayer)

app.route('/v2', browserView)
app.route('/play', browserView)

app.mount('#app')
